module.exports = __webpack_public_path__ + "static/media/ca.72a6d156.webp";